<template>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" @close="close" :close-on-click-modal="false" :close-on-press-escape="false" width="1100px">
        <el-form size="small" :model="form" :label-width="formLabelWidth" ref="form">

            <div class="common-form">基本信息</div>
            <el-descriptions class="margin-top" title="" :column="3" size="medium" border>
                <el-descriptions-item>
                    <template slot="label">活动标题</template>
                    {{ detail.title }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">活动类型</template>
                    {{ detail.activity_type_desc }}
                </el-descriptions-item>

                <el-descriptions-item>
                    <template slot="label">状态</template>
                    {{ detail.status_desc }}
                </el-descriptions-item>

                <el-descriptions-item>
                    <template slot="label">是否显示</template>
                    {{ detail.is_show_desc }}
                </el-descriptions-item>

                <el-descriptions-item>
                    <template slot="label">参与人数</template>
                    {{ detail.enroll_num }}
                </el-descriptions-item>

                <el-descriptions-item>
                    <template slot="label">是否同步投票</template>
                    {{ detail.is_vote === 1 ? '是' : '否' }}
                </el-descriptions-item>

                <el-descriptions-item>
                    <template slot="label">活动/截稿时间</template>
                    {{ detail.activity_time }}
                </el-descriptions-item>

                <el-descriptions-item v-if="detail.activity_type === 2">
                    <template slot="label">活动地点</template>
                    {{ detail.activity_address }}
                </el-descriptions-item>

                <el-descriptions-item>
                    <template slot="label">报名/评选时间</template>
                    {{ detail.start_time }} 至 {{ detail.end_time }}
                </el-descriptions-item>

                <el-descriptions-item v-if="detail.activity_type === 1">
                    <template slot="label">公布时间</template>
                    {{ detail.publish_time }}
                </el-descriptions-item>
            </el-descriptions>

            <div class="common-form" v-if="detail.file_id > 0">附件</div>
            <el-descriptions class="margin-top" title="" :column="1" size="medium" border v-if="detail.file" >
                <el-descriptions-item>
                    <template slot="label">附件</template>
                    <el-link type="primary" target="_blank" :href="detail.file.file_path">{{detail.file.real_name}}</el-link>
                </el-descriptions-item>
            </el-descriptions>

            <div class="common-form">活动内容</div>
            <el-descriptions class="margin-top" title="" :column="1" size="medium" border >
                <el-descriptions-item>
                    <template slot="label">封面</template>
                    <el-image style="height: 40px" fit="contain" v-if="detail.file_path" class="ya-img-table" :src="detail.file_path"
                              :preview-src-list="[detail.file_path]" title="点击查看大图"/>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">内容</template>
                    <div v-html="detail.content"></div>
                </el-descriptions-item>
            </el-descriptions>

            <div class="common-form" v-if="detail.audit">审核信息</div>
            <el-descriptions class="margin-top" title="" :column="1" size="medium" border v-if="detail.audit" >
                <el-descriptions-item>
                    <template slot="label">审核状态</template>
                    <div v-if="detail.audit.status === 1"> 审核通过 </div>
                    <div v-else> 审核不通过 </div>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">审核时间</template>
                   {{ detail.audit.create_time }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">审核内容</template>
                    {{ detail.audit.remark }}
                </el-descriptions-item>
            </el-descriptions>

        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="save" :disabled="submit_loading">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import { activityDetail } from '@/api/education';

    export default {
        components: {},
        data() {
            return {
                title: '详情',
                file_path: '',
                /*左边长度*/
                formLabelWidth: '120px',
                /*是否显示*/
                dialogFormVisible: false,
                /*是否正在提交*/
                submit_loading: false,

                form: {},
                activity_id: '',
                detail: []
            };
        },
        props: ['fetch-data'],
        created() {

        },
        methods: {
            showDialog(row) {
                if (!row) {
                    this.$message({message: '获取详情失败', type: 'error'});
                } else {
                    this.activity_id = row.activity_id
                    this.getDetail()
                }
                this.dialogFormVisible = true
            },
            save() {
                this.close()
            },
            // 关闭
            close() {
                this.$refs['form'].resetFields()
                this.form = this.$options.data().form
                this.dialogFormVisible = false
            },
            getDetail() {
                activityDetail({id: this.activity_id}).then((result) => {
                    this.detail = Object.assign({}, result.data)
                    if(this.detail.video_id > 0){
                        this.detail.video_url = result.data.video.file_path
                    }
                })
            },

        }
    };
</script>

<style scoped>
    .tips {
        color: #ccc;
    }
</style>



// WEBPACK FOOTER //
// src/views/education/video/video/detail.vue